var tr = {
	"neptune.Button.loadingAriaLabel": "yükleniyor",
	"neptune.Chips.ariaLabel": "{choice} temizle",
	"neptune.ClearButton.ariaLabel": "Sil",
	"neptune.CloseButton.ariaLabel": "Kapat",
	"neptune.DateInput.day.label": "Gün",
	"neptune.DateInput.day.placeholder": "GG",
	"neptune.DateInput.month.label": "Ay",
	"neptune.DateInput.year.label": "Yıl",
	"neptune.DateInput.year.placeholder": "YYYY",
	"neptune.DateLookup.day": "gün",
	"neptune.DateLookup.goTo20YearView": "20 yıl görünümüne git",
	"neptune.DateLookup.month": "ay",
	"neptune.DateLookup.next": "devam et",
	"neptune.DateLookup.previous": "önceki",
	"neptune.DateLookup.selected": "seçili",
	"neptune.DateLookup.twentyYears": "20 yıl",
	"neptune.DateLookup.year": "yıl",
	"neptune.FlowNavigation.back": "önceki adıma dön",
	"neptune.Info.ariaLabel": "Daha fazla bilgi",
	"neptune.Label.optional": "(İsteğe bağlı)",
	"neptune.Link.opensInNewTab": "(yeni sekmede açılır)",
	"neptune.MoneyInput.Select.placeholder": "Bir seçenek seçin...",
	"neptune.MoneyInput.Select.selectCurrencyLabel": "Para birimi seçin",
	"neptune.PhoneNumberInput.SelectInput.placeholder": "Bir seçenek seçin...",
	"neptune.Select.searchPlaceholder": "Ara...",
	"neptune.SelectInput.noResultsFound": "Sonuç bulunamadı",
	"neptune.SelectOption.action.label": "Seç",
	"neptune.SelectOption.selected.action.label": "Seçilen opsiyonu değiştir",
	"neptune.StatusIcon.iconLabel.error": "Hata:",
	"neptune.StatusIcon.iconLabel.information": "Bilgi:",
	"neptune.StatusIcon.iconLabel.pending": "Bekliyor:",
	"neptune.StatusIcon.iconLabel.success": "Başarılı:",
	"neptune.StatusIcon.iconLabel.warning": "Uyarı:",
	"neptune.Summary.statusDone": "Tamamlanan aşama",
	"neptune.Summary.statusNotDone": "Yapılacak",
	"neptune.Summary.statusPending": "Bekliyor",
	"neptune.Table.actionHeader": "Eylem",
	"neptune.Table.emptyData": "Sonuç bulunamadı",
	"neptune.Table.loaded": "Tablo verileri yüklendi",
	"neptune.Table.loading": "Tablo verileri yükleniyor",
	"neptune.Table.refreshPage": "Sayfayı yenile",
	"neptune.Upload.csButtonText": "Başka bir dosya yükleyin?",
	"neptune.Upload.csFailureText": "Yükleme başarısız. Lütfen yine deneyin",
	"neptune.Upload.csSuccessText": "Yükleme tamamlandı!",
	"neptune.Upload.csTooLargeMessage": "Lütfen {maxSize} MB'den küçük bir dosya sağlayın",
	"neptune.Upload.csWrongTypeMessage": "Desteklenmeyen dosya biçimi. Lütfen başka bir dosyayla tekrar deneyin",
	"neptune.Upload.psButtonText": "İptal edin",
	"neptune.Upload.psProcessingText": "Yükleniyor...",
	"neptune.Upload.retry": "Tekrar deneyin",
	"neptune.Upload.usButtonText": "Veya bir dosya seçin",
	"neptune.Upload.usDropMessage": "Yüklemeyi başlatmak için dosyayı bırakın",
	"neptune.Upload.usPlaceholder": "{maxSize} MB'den küçük bir dosya sürükleyin ve bırakın",
	"neptune.UploadButton.allFileTypes": "Tüm belge tipleri",
	"neptune.UploadButton.dropFiles": "Yüklemeyi başlatmak için dosyayı bırakın",
	"neptune.UploadButton.instructions": "{fileTypes}, en fazla {size}MB",
	"neptune.UploadButton.maximumFiles": "En fazla {maxFiles} dosya.",
	"neptune.UploadButton.uploadFile": "Dosya yükleyin",
	"neptune.UploadButton.uploadFiles": "Dosya yükleyin",
	"neptune.UploadInput.deleteModalBody": "Bu belgeyi kaldırmak, sistemimizden tamamen silinmesiyle sonuçlanır.",
	"neptune.UploadInput.deleteModalCancelButtonText": "İptal et",
	"neptune.UploadInput.deleteModalConfirmButtonText": "Kaldır",
	"neptune.UploadInput.deleteModalTitle": "Bu dosyayı kaldırmak istediğinizden emin misiniz?",
	"neptune.UploadInput.fileIsTooLarge": "Dosya çok büyük",
	"neptune.UploadInput.fileTypeNotSupported": "Dosya tipi desteklenmiyor",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "Üzgünüz, bu yükleme aynı anda en fazla {maxFilesAllowed} dosya kabul edebildiğimiz için başarısız oldu.",
	"neptune.UploadItem.deleting": "Siliniyor...",
	"neptune.UploadItem.removeFile": "{filename} dosyasını kaldır",
	"neptune.UploadItem.uploaded": "Yüklendi",
	"neptune.UploadItem.uploadedFile": "Yüklenen belge",
	"neptune.UploadItem.uploading": "Yükleniyor...",
	"neptune.UploadItem.uploadingFailed": "Dosya yüklenemedi"
};

export { tr as default };
//# sourceMappingURL=tr.json.mjs.map
